import { Link } from "react-router-dom";

interface EmptyStateProps {
  icon?: string;
  title: string;
  description?: string;
  actionLabel?: string;
  onAction?: () => void;
  actionTo?: string;
}

export default function EmptyState({
  icon = "ri-inbox-line",
  title,
  description,
  actionLabel,
  onAction,
  actionTo,
}: EmptyStateProps) {
  const actionClass =
    "inline-flex items-center gap-1.5 px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 whitespace-nowrap cursor-pointer transition-colors";

  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-4">
      <span className="flex items-center justify-center w-16 h-16 rounded-full bg-background-100 text-foreground-400 mb-4">
        <i className={`${icon} text-3xl`} />
      </span>
      <h3 className="text-base md:text-lg font-semibold text-foreground-900">{title}</h3>
      {description && (
        <p className="mt-1.5 text-sm text-foreground-500 max-w-md">{description}</p>
      )}
      {actionLabel && actionTo && (
        <Link to={actionTo} className={`${actionClass} mt-5`}>
          {actionLabel}
        </Link>
      )}
      {actionLabel && !actionTo && onAction && (
        <button type="button" onClick={onAction} className={`${actionClass} mt-5`}>
          {actionLabel}
        </button>
      )}
    </div>
  );
}